const DashboardTab = {
    FINANCE: 0,
    HR: 1
}

export default DashboardTab;